import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 20C12.4533 20 12.8336 19.8464 13.1408 19.5392C13.4469 19.2331 13.6 18.8533 13.6 18.4V13.6H18.44C18.8933 13.6 19.2667 13.4464 19.56 13.1392C19.8533 12.8331 20 12.4533 20 12C20 11.5467 19.8464 11.1664 19.5392 10.8592C19.2331 10.5531 18.8533 10.4 18.4 10.4H13.6V5.56C13.6 5.10667 13.4469 4.73333 13.1408 4.44C12.8336 4.14667 12.4533 4 12 4C11.5467 4 11.1669 4.15307 10.8608 4.4592C10.5536 4.7664 10.4 5.14667 10.4 5.6V10.4H5.56C5.10667 10.4 4.73333 10.5531 4.44 10.8592C4.14667 11.1664 4 11.5467 4 12C4 12.4533 4.15307 12.8331 4.4592 13.1392C4.7664 13.4464 5.14667 13.6 5.6 13.6H10.4V18.44C10.4 18.8933 10.5536 19.2667 10.8608 19.56C11.1669 19.8533 11.5467 20 12 20Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
